<template>

  <div class="content-container">

    <!-- Fortschrittsbalken -->
    <div class="progress-container">
      <div class="progress-bar"></div>
    </div>

    <!-- Text -->
    <h2 class="primary-text mt-4 mb-4 align-center text-h4">Welchen Pflegegrad haben Sie?</h2>

    <div class="d-flex justify-space-between align-center w-100">
    <v-btn
        class="care-btn elevation-0"
        @mouseover="elevateButton"
        @mouseleave="deElevateButton"
        @click="handleClick1"
        large
        color="gradient-primary"
        style="width: 18%; height: 300px; font-size: 30px;"
    >
      <div class="d-flex flex-column align-center justify-center" style="width: 100%; height: 100%;">
        <img class="icon-img" src="https://www.docdorado.de/media/6b/84/66/1695582195/großvater-80.png" alt="Pflegegrad 1" />
        <span class="mt-4">Pflegegrad 1</span>
      </div>
    </v-btn>
    <v-btn
        class="care-btn elevation-0"
        @mouseover="elevateButton"
        @mouseleave="deElevateButton"
        @click="handleClick2"
        large
        color="gradient-primary"
        style="width: 18%; height: 300px; font-size: 30px;"
    >
      <div class="d-flex flex-column align-center justify-center" style="width: 100%; height: 100%;">
        <img class="icon-img" src="https://www.docdorado.de/media/c5/7a/73/1695582195/gehhilfe-50.png" alt="Pflegegrad 2" />
        <span class="mt-4">Pflegegrad 2</span>
      </div>
    </v-btn><v-btn
      class="care-btn elevation-0"
      @mouseover="elevateButton"
      @mouseleave="deElevateButton"
      @click="handleClick3"
      large
      color="gradient-primary"
      style="width: 18%; height: 300px; font-size: 30px;"
  >
    <div class="d-flex flex-column align-center justify-center" style="width: 100%; height: 100%;">
      <img class="icon-img" src="https://www.docdorado.de/media/a8/ff/12/1695582195/rollstuhl-50.png" alt="Pflegegrad 3" />
      <span class="mt-4">Pflegegrad 3</span>
    </div>
  </v-btn><v-btn
      class="care-btn elevation-0"
      @mouseover="elevateButton"
      @mouseleave="deElevateButton"
      @click="handleClick4"
      large
      color="gradient-primary"
      style="width: 18%; height: 300px; font-size: 30px;"
  >
    <div class="d-flex flex-column align-center justify-center" style="width: 100%; height: 100%;">
      <img class="icon-img" src="https://www.docdorado.de/media/96/02/f4/1695582195/leeres-bett-80.png" alt="Pflegegrad 4" />
      <span class="mt-4">Pflegegrad 4</span>
    </div>
  </v-btn><v-btn
      class="care-btn elevation-0"
      @mouseover="elevateButton"
      @mouseleave="deElevateButton"
      @click="handleClick5"
      large
      color="gradient-primary"
      style="width: 18%; height: 300px; font-size: 30px;"
  >
    <div class="d-flex flex-column align-center justify-center" style="width: 100%; height: 100%;">
      <img class="icon-img" src="https://www.docdorado.de/media/f7/15/4a/1695582195/krankenhausbett-40.png" alt="Pflegegrad 5" />
      <span class="mt-4">Pflegegrad 5</span>
    </div>
  </v-btn>
  </div>

    <div v-observe-visibility="onVisibilityChanged" class="statistics-container">
      <div class="statistic-item">
        <v-icon color="primary" class="stat-icon">mdi-account-group</v-icon> <!-- Icon für Pflegebedürftige -->
        <p class="stat-number">{{ animatedNumber1 }}+</p>
        <p class="stat-label">Pflegebedürftige versorgt</p>
      </div>

      <div class="statistic-item">
        <v-icon color="primary" class="stat-icon">mdi-emoticon-happy</v-icon> <!-- Icon für Zufriedenheit -->
        <p class="stat-number">{{ animatedNumber2 }}%</p>
        <p class="stat-label">Zufriedenheitsquote</p>
      </div>

      <div class="statistic-item">
        <v-icon color="primary" class="stat-icon">mdi-box-cutter</v-icon> <!-- Icon für Pflegeboxen -->
        <p class="stat-number">{{ animatedNumber3 }}+</p>
        <p class="stat-label">Pflegeboxen zugestellt</p>
      </div>
    </div>

  </div>
</template>

<script>

import {mapGetters, mapState} from "vuex";
import {mapFields} from "vuex-map-fields";

export default {
  data() {
    return {
      animatedNumber1: 0,
      animatedNumber2: 0,
      animatedNumber3: 0
    };
  },
  methods: {
    elevateButton(event) {
      event.currentTarget.classList.remove('elevation-0');
      event.currentTarget.classList.add('elevation-5');
    },
    deElevateButton(event) {
      event.currentTarget.classList.remove('elevation-5');
      event.currentTarget.classList.add('elevation-0');
    },
    onVisibilityChanged(isVisible, entry) {
      if (isVisible) {
        this.animateNumbers();
      }
    },
    animateNumbers() {
      let start1 = 0, end1 = 34000, duration1 = 2000;
      let start2 = 0, end2 = 98, duration2 = 2000;
      let start3 = 0, end3 = 270000, duration3 = 2000;

      let startTime = Date.now();

      const incrementNumber = () => {
        let elapsedTime = Date.now() - startTime;

        if (elapsedTime < duration1) {
          this.animatedNumber1 = Math.round(start1 + (end1 - start1) * (elapsedTime / duration1));
        }

        if (elapsedTime < duration2) {
          this.animatedNumber2 = Math.round(start2 + (end2 - start2) * (elapsedTime / duration2));
        }

        if (elapsedTime < duration3) {
          this.animatedNumber3 = Math.round(start3 + (end3 - start3) * (elapsedTime / duration3));
        }

        if (elapsedTime < Math.max(duration1, duration2, duration3)) {
          requestAnimationFrame(incrementNumber);
        }
      }

      incrementNumber();
    },
    handleClick1() {
      this.$router.push('/versicherung');
      this.setCareDegree(1);
    },
    handleClick2() {
      this.$router.push('/versicherung');
      this.setCareDegree(2);
    },
    handleClick3() {
      this.$router.push('/versicherung');
      this.setCareDegree(3);
    },
    handleClick4() {
      this.$router.push('/versicherung');
      this.setCareDegree(4);
    },
    handleClick5() {
      this.$router.push('/versicherung');
      this.setCareDegree(5);
    },
    setCareDegree(careDegree) {
      this.$store.commit('setCareDegree', careDegree);
    },
  },
  mounted() {
    // Die 'mouseout'-Funktionalität, die Sie zuvor hatten, wurde hier entfernt, da Sie sagten, dass wir sie nicht mehr benötigen.
  },
  computed: {
    ...mapFields([
      'customer.careDegree',
    ]),
  }
}
</script>



<style scoped>
.care-btn {
  margin: 0 10px;
  width: 14%;  /* kleinere Button-Breite */
  height: 250px; /* kleinere Button-Höhe */
  font-size: 24px; /* kleinerer Schriftgrad */
}
.care-btn:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.icon-img {
  width: 60px; /* kleinere Bildgröße */
  height: 60px;
}

.gradient-primary {
  background: linear-gradient(315deg, #f9ad18, #f98918 80%);
  color: white; /* Setzen Sie eine Farbe für den Text, die gut mit dem Gradienten harmoniert */
}

.content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 80vh; /* Nehmen Sie die volle Höhe des Viewports */
  padding: 0 15px; /* Einige zusätzliche Polsterung an den Seiten, falls gewünscht */
}

.statistics-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  margin-top: 50px; /* zusätzlicher Abstand zu den Buttons */
}

.statistic-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.stat-icon {
  font-size: 60px; /* Größere Icons */
  margin-bottom: 20px; /* Abstand zwischen Icon und Zahl */
}

.stat-number {
  font-size: 40px; /* Größere Zahl */
  font-weight: bold; /* Dickere Zahl */
  margin-bottom: 10px; /* Abstand zwischen Zahl und Beschreibung */
}

.stat-label {
  font-size: 18px;
  text-align: center;
}

.progress-container {
  width: 40%;
  height: 20px;
  background-color: #f0f0f0; /* Hintergrundfarbe des Fortschrittsbalkens */
}

.progress-bar {
  width: 40%; /* 2 von 5 Schritten -> 40% */
  height: 100%;
  background-color: var(--v-primary-base); /* Primärfarbe des Fortschrittsbalkens */
}
</style>